import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { ChipValueType } from './types';

const initialState: {
  chips: ChipValueType[];
  chipsReady: boolean;
  selectedChip: ChipValueType | null;
} = {
  chips: [],
  chipsReady: false,
  selectedChip: null,
};

export const chipSlice = createSlice({
  name: 'chips',
  initialState,
  reducers: {
    setChips: (state, action: PayloadAction<ChipValueType[]>) => {
      state.chips = action.payload;
      state.chipsReady = true;
    },
    setSelectedChip: (state, action: PayloadAction<ChipValueType>) => {
      state.selectedChip = action.payload;
    },
    // settingSyncMiddleware listens for this action to save selected chip in playerConfig on server
    setAndSyncSelectedChip: (state, action: PayloadAction<ChipValueType>) => {
      state.selectedChip = action.payload;
    },
  },
});

export const chipActions = chipSlice.actions;
